import { Link } from 'react-router';

import { appBarNavLinkClicked } from 'my-core/gtm-events';

import AppBarNavLink from './AppBarNavLink';

import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ palette, spacing }) => ({
  minWidth: 150,
  maxWidth: '100%',
  '.UM-menuList': {
    position: 'relative',
    padding: spacing(1.5, 0),
    '& + .UM-menuList:before': {
      content: '""',
      position: 'absolute',
      top: -1,
      left: spacing(2),
      right: spacing(2),
      height: 1,
      backgroundColor: palette.divider,
    },
  },
  '.UM-buttonWrapper': {
    padding: spacing(0, 2),
    '& + .UM-buttonWrapper': { marginTop: spacing(1) },
  },
  '.UM-button': {
    padding: spacing(1, 4),
  },
  '.UM-icon': {
    marginRight: spacing(1),
  },
});

export default function UserMenu({ items, location, navLinks, setOpen }) {
  return (
    <Paper css={rootCss} elevation={0} square>
      {navLinks && (
        <div className="UM-menuList">
          <AppBarNavLink inline items={navLinks} location={location} onChangeOpen={setOpen} />
        </div>
      )}
      {items
        .map(
          (list, listIndex) =>
            list.length && (
              <MenuList key={listIndex} className="UM-menuList" component="div" disablePadding>
                {list.map(({ button, href, icon, label, onClick, path }) => {
                  const commonProps =
                    path ?
                      {
                        component: Link,
                        nativeButton: false,
                        to: path,
                        onClick: () => {
                          appBarNavLinkClicked(label);
                          setOpen(false);
                        },
                      }
                    : href ?
                      {
                        component: 'a',
                        nativeButton: false,
                        href,
                        target: '_blank',
                        rel: 'noreferrer',
                        onClick: () => {
                          appBarNavLinkClicked(label);
                          setOpen(false);
                        },
                      }
                    : {
                        onClick: e => {
                          setOpen(false);
                          appBarNavLinkClicked(label);
                          onClick(e);
                        },
                      };
                  return button ?
                      <div key={label} className="UM-buttonWrapper">
                        <Button
                          className="UM-button"
                          fullWidth
                          size="small"
                          startIcon={icon && <FontAwesomeIcon icon={icon} />}
                          variant={button}
                          {...commonProps}
                        >
                          {label}
                        </Button>
                      </div>
                    : <MenuItem key={label} component="div" dense nativeButton={false} {...commonProps}>
                        {icon && <FontAwesomeIcon className="UM-icon" icon={icon} />}
                        {label}
                      </MenuItem>;
                })}
              </MenuList>
            ),
        )
        .filter(Boolean)}
    </Paper>
  );
}
